<template>
  <div>
    <!-- 订单详情标签补打原因登记；此组件只服务订单详情页面。 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="480px" center>
      <div class="content">
        <div class="text">注意：已打印标签再次打印前需要登记原因，请谨慎操作</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('message.applicationQuantity')" prop="num">
            <el-input v-model="ruleForm.num" type="number" @input="handleInput"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.reasonForApplication')" prop="print_reason">
            <el-select v-model="ruleForm.print_reason" placeholder="请选择" clearable>
              <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.label"></el-option>
            </el-select>
            <el-input v-model="ruleForm.print_reason" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{ $t("message.cancel") }}</el-button>
        <el-button type="primary" @click="save">{{ $t("message.ok") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    orderDetailTagId: { type: [String, Number], default: '' },
    saveHandler: { type: Function, default: null },
  },
  data() {
    return {
      options: [
        { label: '打印机故障' },
        { label: '换卷纸' },
        { label: '标签破损' },
        { label: '操作失误' },
      ],
      ruleForm: { num: 1, print_reason: '' },
      dialogVisible: false,
      rules: {
        num: [{ required: true, message: this.$t("message.thisParameterCannotBeEmpty"), trigger: "blur" }],
        print_reason: [{ required: true, message: this.$t("message.thisParameterCannotBeEmpty"), trigger: "blur" }],
      },
    }
  },
  watch: {
    dialogVisible(value) {
      if (value) this.ruleForm = { num: 1, print_reason: '' }
    },
  },
  methods: {
    cancel() {
      this.dialogVisible = false
      this.$emit("cancel")
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return
        const data = {
          order_detail_tag_id: this.orderDetailTagId,
          print_reason: this.ruleForm.print_reason,
          num: Number(this.ruleForm.num),
        }
        if (!this.saveHandler) return
        Promise.resolve(this.saveHandler(data)).then(() => {
          this.$emit('print', data.num)
          this.dialogVisible = false
        }).catch(() => {})
      })
    },
    // 与配送单保持一致，禁止输入负数或非数字数量。
    handleInput(value) {
      const number = Number(String(value).replace(/^-/, ''))
      this.ruleForm.num = isNaN(number) || number < 0 ? '' : number.toString()
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 15px;

  .text {
    color: red;
    font-size: 16px;
    font-weight: 600;
    margin: 24px 0;
  }

  /deep/.el-textarea__inner {
    height: 100px !important;
    resize: none;
  }
}
</style>
